import React from 'react';
import { headerData } from '../../data/headerData';
import { contactsData } from '../../data/contactsData';
import './Footer.css';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <span className="footer-name">{headerData.name}</span>

        <div className="footer-links">
          <a href={contactsData.linkedIn} target="_blank" rel="noreferrer">
            LinkedIn
          </a>
          <a href={contactsData.github} target="_blank" rel="noreferrer">
            GitHub
          </a>
          <a href={`mailto:${contactsData.email}`}>Email</a>
        </div>

        <p className="footer-copy">
          © {new Date().getFullYear()} Built with React.js, Lenis & GSAP
        </p>
      </div>
    </footer>
  );
}

export default Footer;
